module.exports = __webpack_public_path__ + "static/man_set_2preschool.f530d209.svg";